import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bra-checkbox',
  templateUrl: './bra-checkbox.component.html',
  styleUrls: ['./bra-checkbox.component.css']
})
export class BraCheckboxComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/componentes/bra-checkbox/bra-checkbox.component.ts